import { css, html, svg } from 'lit';
import { customElement, property } from 'lit/decorators';
import { classMap } from 'lit/directives/class-map';
import { DeviceAwareComponent } from './device-aware-component';

const Arcs = svg`
<svg class="arcs" viewbox="-2 -2 44 44">
  <path fill="none" class="q1" stroke="currentColor" stroke-width="2" d="M20,0 a20,20 0 0,1 20,20" />
  <path fill="none" class="q2" stroke="currentColor" stroke-width="2" d="M40,20 a20,20 0 0,1 -20,20" />
  <path fill="none" class="q3" stroke="currentColor" stroke-width="2" d="M20,40 a20,20 0 0,1 -20,-20" />
  <path fill="none" class="q4" stroke="currentColor" stroke-width="2" d="M0,20 a20,20 0 0,1 20,-20" />
</svg>
`;


@customElement('arc-progress')
export class ArcProgress extends DeviceAwareComponent {
  @property({ attribute: 'value', type: Number, reflect: true })
    value: number = 0; // zero to one
  static get styles() {
    return [
      css`
        :host {
          display: inline-block;
          margin: 0;
          padding: 0;
        width: 3rem;
        height: 3rem;
      }
      .arcs {
        width: var(--custom-width-arc, calc(100% + 0.05rem));
        height: calc(100% + 4px);
        margin-block-start: var(--offset, 0);
        margin-inline-start: var(--custom-inline-start, 0.2rem);
      }
      .q1,
      .q2,
      .q3,
      .q4 {
        visibility: hidden;
      }

      #wrapper.a1 .q1 {
        visibility: visible;
      }
      #wrapper.a2 .q1,
      #wrapper.a2 .q2 {
        visibility: visible;
      }
      #wrapper.a3 .q1,
      #wrapper.a3 .q2,
      #wrapper.a3 .q3 {
        visibility: visible;
      }
      #wrapper.a4 .q1,
      #wrapper.a4 .q2,
      #wrapper.a4 .q3,
      #wrapper.a4 .q4 {
        visibility: visible;
      }
    `,
    ];
  };

  render() {
    const { value } = this;
    const cs = {
      a1: value > 0 && value <= 0.325,
      a2: value > 0.325 && value <= 0.625,
      a3: value > 0.625 && value < 1,
      a4: value >= 1,
    };
    return html` <span id="wrapper" class=${classMap(cs)}>${Arcs}</span> `;
  }
}
